/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useEffect } from 'react';
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import OnboardingStart from '../../components/OnboardingStart';
import { getKnowledgeBase } from '../../knowledge-base/actions/KnowledgeBaseActions';
import { selectKnowledgeBase, selectKnowledgeBasesFetched, selectKnowledgeBasesNotFetched } from '../../knowledge-base/selectors/knowledgeBaseDetails';
import { useAppDispatch, useAppSelector } from '../../utils/hooks';
import { KB_ONBOARDING_PATH } from '../constants/RouteConstants';
import { jsx as _jsx } from "react/jsx-runtime";
const MaybeShowZeroState = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const {
    search
  } = useLocation();
  const needsToFetchKnowledgeBase = useAppSelector(selectKnowledgeBasesNotFetched);
  const hasFetchedKnowledgeBases = useAppSelector(selectKnowledgeBasesFetched);
  const defaultKnowledgeBaseId = useAppSelector(state => {
    const currentKnowledgeBase = selectKnowledgeBase(state);
    return currentKnowledgeBase ? currentKnowledgeBase.id : null;
  });
  useEffect(() => {
    if (needsToFetchKnowledgeBase) {
      dispatch(getKnowledgeBase());
    }
  }, [dispatch, needsToFetchKnowledgeBase]);
  if (!hasFetchedKnowledgeBases) {
    return null;
  }
  if (defaultKnowledgeBaseId === null) {
    return /*#__PURE__*/_jsx(OnboardingStart, {
      isSetupDisabled: false,
      onClick: () => history.push(`${KB_ONBOARDING_PATH}?cancel=back`)
    });
  }
  return /*#__PURE__*/_jsx(Redirect, {
    from: "/",
    to: `/${defaultKnowledgeBaseId}/${search}`
  });
};
export default MaybeShowZeroState;